<div [ngSwitch]="group.layout">
    <wuc-card cardStyle="primary" padding="large"
              [additionalContentLocation]="!input?.price ? 'top-right' : null"
              [class.coverage-implicit__free-label]="!input?.price"
              [class.coverage-implicit--border-bottom]="group.hasBorder"
              *ngSwitchCase="coverageGroupLayoutEnum.Card">
        <div class="coverage-implicit__header">
            <div class="coverage-implicit__header--left">
                <h3>{{ input?.data?.title }}</h3>
                <wuc-card *ngIf="input?.featured" padding="none" cardStyle="tertiary"
                          class="coverage-implicit__featured">
                    <wuc-text-highlight type="secondary">
                        Meest gekozen
                    </wuc-text-highlight>
                </wuc-card>
                <wuc-price *ngIf="input?.price > 0" [price]="input?.price" class="coverage-implicit__price"></wuc-price>
                <div class="coverage-implicit__body" *ngIf="input?.data?.body" [innerHTML]="input?.data?.body"></div>
            </div>
        </div>

        <ng-container slot="additionalContent" *ngIf="!input?.price">
            <wuc-scribble-circle scribbleText="Inclusief"></wuc-scribble-circle>
        </ng-container>
    </wuc-card>

    <div class="coverage-implicit__default"
         [class.coverage-implicit--border-bottom]="group.hasBorder"
         *ngSwitchDefault>
        <div class="coverage-implicit__left-column">
            <wuc-icon-ui icon="check-closed" size="xs" type="primary"></wuc-icon-ui>
            <div class="coverage-implicit__title">
                {{input?.data?.title}}
                <wuc-card *ngIf="input?.featured" padding="none" cardStyle="tertiary" class="coverage-implicit__featured">
                    <wuc-text-highlight type="secondary">
                        Meest gekozen
                    </wuc-text-highlight>
                </wuc-card>
            </div>
        </div>
        <div class="coverage-implicit__right-column">
            <wuc-link *ngIf="input?.data?.body || input?.data?.tabs" type="secondary" (click)="displayInformation(input?.data)">
                meer info
            </wuc-link>
            <span *ngIf="input?.price === 0" class="coverage-implicit__free">gratis</span>
            <wuc-price *ngIf="input?.price > 0" [price]="input?.price"></wuc-price>
        </div>
    </div>
</div>
